import { combineReducers } from "redux";
import { resetApp } from "pages/slice";
import signupReducer from "pages/signup_slice";
import { enrollmentApi } from "pages/slice";

const combinedReducer = combineReducers({
  signup: signupReducer,
  [enrollmentApi.reducerPath]: enrollmentApi.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === resetApp.type) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
